import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";

export const renderColumns = (
  handleEdit,
  handleDelete,
  onCheck,
  checkAll,
  onCheckAll
) => {
  return [
    {
      dataIndex: "checkbox",
      key: "checkbox",
      title: (
        <input
          type="checkbox"
          id={`label-check-all`}
          checked={checkAll}
          onClick={(event) => onCheckAll()}
        />
      ),
      render: (_, record) => (
        <input
          type="checkbox"
          id={`label-check-${record.id}`}
          checked={record.is_checked}
          onClick={(event) => onCheck(record)}
        />
      ),
    },
    {
      dataIndex: "shelf_code",
      key: "shelf_code",
      title: "Kode Shelf",
    },
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Shelf",
    },
    {
      dataIndex: "storage_name",
      key: "storage_name",
      title: "Nama Storage",
      render: (_, record) => <p className="m-0">{record.storage.name}</p>,
    },
    {
      dataIndex: "address",
      key: "address",
      title: "Lokasi Storage",
    },
    {
      dataIndex: "product_category.name",
      key: "product_category.name",
      title: "Kategori Produk",
      render: (_, record) => (
        <p className="m-0">{record.product_category.name}</p>
      ),
    },
    {
      dataIndex: "max_item",
      key: "max_item",
      title: "Maks. Barang",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "7%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_shelf}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          <CanAccess
            role={AuthorizationList.delete_shelf}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
